import { Injectable } from '@angular/core';
import { ValidationStateService } from '@r1-compass-library/features/validation-sync';
import { LifecycleRulesSectionName } from '@r1-compass-library/features/validation-sync';
import { AppConstants } from '../app.constants';

@Injectable({
    providedIn: 'root',
})
export class LifecycleRulesValidationStateService extends ValidationStateService<LifecycleRulesSectionName> {
    constructor() {
        super(AppConstants.LifecycleRulesComponent.children);
    }
}
